import { create } from 'zustand';

type State = {
  storeConversationId?: string;
};

type Actions = {
  setStoreConversationId: (conversationId?: string) => void;
};

export const useConversionStore = create<State & Actions>((set) => ({
  storeConversationId: '',
  setStoreConversationId: (storeConversationId) => set({ storeConversationId }),
}));
